export default __webpack_public_path__ + "static/media/readMoreArrow.d9800b45.svg";